import React from 'react';
import MerchantRebate from 'core/modules/MerchantRebate/MerchantRebate';

import './PopularOffer.scss';

function PopularOffer({
  id, assets, merchant, clickUrl, config,
}) {
  const { rebateOptions } = config;

  return (
    <div className="mn_offerWrap mn_popularOffer">
      <a
        href={clickUrl}
        title={`Opens a new window at ${merchant.name}`}
        target="_blank"
        data-offer-id={id}
        data-merchant-name={merchant.name}
        data-offer-copy={assets.imageAlternateText}
      >
        <img src={assets._300x250} alt={assets.imageAlternateTextCustom} />
        <div
          className="mn_rebate"
          data-test="popular-offer-rebate"
        >
          <MerchantRebate {...merchant.rebate} {...rebateOptions} showRebateInline hideElevationCurrency />
        </div>
      </a>
    </div>
  );
}

export default PopularOffer;
